export function cleanUrl(url: string | undefined | null, baseUrl?: RegExp) {
  if (url === null || url === undefined || url.startsWith('#')) {
    return url;
  }

  if (baseUrl) {
    url = url.replace(baseUrl, '');
  }

  if (!url.startsWith('/')) {
    url = '/' + url;
  }

  return url;
}

export function urlIsAppNavigation(url: string | undefined | null) {
  try {
    if (!url || url === '#') {
      return false;
    }
    return !/\/?[^/.]*\.[^/.]*$/.test(url);
  } catch (e) {
    console.error(e);
    return false;
  }
}

export function concatUrlSegments(...segments: string[]) {
  // Remove any leading or trailing slashes from each segment
  const cleanedSegments = segments
    .filter(Boolean)
    .map((segment) => segment.replace(/^\/+|\/+$/g, ''));

  // Join the cleaned segments with a single slash
  return cleanedSegments.filter(Boolean).join('/');
}

export function buildUrl(
  baseUrl: string,
  path: string,
  params: Record<string, any> = {},
) {
  const urlObj = new URL(path, baseUrl || window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      urlObj.searchParams.append(key, String(value));
    }
  });
  return urlObj.toString();
}
